import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-log-out-page',
    templateUrl: './log-out-page.component.html',
    styleUrls: ['./log-out-page.component.scss'],
    imports: [MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatCardActions, MatButton]
})
export class LogOutPageComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  logIn(){
    this.router.navigate(['/login'])
  }

}
